<template>
    <div class="component">
        <div class="main-title">
            <div class="square"></div>
            <div class="title-content">技能概览</div>
        </div>
        <div class="main-content">
            <portrait-labels :labelList="componentData.skillOverview"></portrait-labels>
            <div class="sub" v-if="componentData.majorSkill!=null&&componentData.majorSkill.length>0">
                <div class="sub-title">
                    专业技能明细
                </div>
                <div class="sub-content">
                    <el-table
                            :data="componentData.majorSkill"
                            style="{width:100%}"
                            :header-cell-style="{background:'#F2F2F2',height: '32px','font-size': '12px',color: '#212121'}"
                            :cell-style="{'font-size': '12px',color: '#212121'}">
                        <el-table-column
                                prop="skillName"
                                label="技能名称"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="skillLevel"
                                label="掌握程度"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="skillPrj"
                                label="项目"
                                :formatter="fileData">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="sub-row" v-if="componentData.languageSkill!=null&&componentData.languageSkill.length>0">
                <div class="sub-title">
                    语言技能
                </div>
                <portrait-labels :labelList="componentData.languageSkill"></portrait-labels>
            </div>
            <div class="sub-row" v-if="componentData.certificate!=null&&componentData.certificate.length>0">
                <div class="sub-title">
                    证书
                </div>
                <portrait-labels :labelList="componentData.certificate"></portrait-labels>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "TabWork",
        props: {
            componentData: [Object, Array]
        },
        data() {
            return {}
        },
        mounted() {
        },
        methods: {
            fileData(row) {
                let skillPrj = (row && row.skillPrj) || [];
                let arr = [];
                skillPrj.forEach(function (item) {
                    arr.push(item);
                });
                return arr.join('、')
            }
        },
    }
</script>

<style lang="less">
.el-table{
  .el-table__header-wrapper{
    th{
      padding: 0 !important;
      color: #212121 !important;
      font-weight: 400 !important;
      div{
        margin-top: 4px;
      }
    }
  }
  .el-table__body-wrapper{
    td{
      padding: 8px 0 !important;
    }
  }
}
</style>
